module.exports = __webpack_public_path__ + "img/access-drop-down.3328d09a.svg";